import React from 'react';
import { ReactComponent as FigChevronDownComponent } from './FigChevronDown.svg';

const FigChevronDown = (props) => <FigChevronDownComponent {...props} />;

export default FigChevronDown;
